exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ndiv[data-v-7ba6053c]{\n      width: 90%;\n      color:white;\n      text-align: center;\n      background-color: #0c4361;\n      align-items: center;\n      padding: 10px;\n\n      margin-left: auto;\n      margin-right: auto;\n}\nbutton[data-v-7ba6053c] {\n    width: 80%;\n    margin-bottom: 10px;\n    height: 30px;\n    font-size: large;\n    color:white;\n    background-color: #3490dc;\n    border: grey;\n    box-shadow: 0 5px 15px 0px rgba(0,0,0,0.6);\n}\n", ""]);

// exports
